import React, { useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import ShipContainer from "../../assets/ShipContainer.jpg";
import Shipment from "../../components/Shipment/Shipment";
import "./Faq.css";
import ChatWithUs from "../../components/ChatWithUs/ChatWithUs";

const faqData = [
  {
    question: "Who are our clients?",
    answer:
      "From SME Importers to Large Businesses (such as supermarket chains, department stores, etc), we serve all types of customers with various product lines.",
  },
  {
    question: "What is the minimum orders that we can accept?",
    answer:
      "Every product has certain minimum quantities that have to be met. Once the minimum order quantity (MOQ) requirements are fulfilled, we are able to export the product.",
  },
  {
    question: "What is the minimum order value that we can supply?",
    answer:
      "We can support small orders (provided product minimum quantity requirements are fulfilled), please contact us to know more about this.",
  },
  {
    question: "How do we ship the goods?",
    answer:
      "We can ship the goods by both Sea and Air (Including Couriers such as DHL, TNT, FedEx).",
  },
  {
    question: "Which shipment methods do we suggest?",
    answer: `We are able to curate cost-effective solutions. However, key deciding factors are:
a) Cost: Air shipments are more expensive than sea.
b) Time: Air shipment is much faster than sea.
c) Volume of goods: Courier cost for small shipments can be cost-effective as they are door-to-door and skip local charges at destination.`,
  },
  {
    question: "What kind of packaging do we offer?",
    answer:
      "Depending on the products, we are able to provide various kinds of packaging options as per clients' requirements.",
  },
  {
    question:
      "Can we do private labeling / customized packaging / OEM of products?",
    answer:
      "That is what we love to do. If you have a brand name in mind (that is not conflicting with any other brands internationally), we can definitely provide products in your private label.",
  },
  {
    question: "What are our main strengths?",
    answer:
      "Product sourcing, product development, inspection and quality control, private labeling / OEM, smooth product shipping experience, and more.",
  },
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAnswer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <Navbar />
      <div className="faq-container">
        <div className="faq-left">
          <h2 className="faq-title">Frequently Asked Questions</h2>
          <div className="faq-box">
            {faqData.map((item, index) => (
              <div key={index}>
                <div
                  className="faq-question"
                  onClick={() => toggleAnswer(index)}
                >
                  {item.question}
                  <span className="faq-toggle">
                    {openIndex === index ? "−" : "+"}
                  </span>
                </div>
                <div
                  className={`faq-answer ${openIndex === index ? "open" : ""}`}
                >
                  {item.answer.split("\n").map((line, i) => (
                    <p key={i}>{line}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="faq-right">
          <img
            src={ShipContainer}
            alt="Shipping Container"
            className="faq-image"
          />
        </div>
      </div>
      <Shipment />
      <Footer />
      <ChatWithUs />
    </>
  );
};

export default Faq;
